import { useSelector, useDispatch } from 'react-redux';
import { getSpamProtectionMetadata } from '../../selectors/widgetDataSelectors/getSpamProtectionMetadata';
import PillLauncherExpandedView from 'conversations-visitor-experience-components/visitor-widget/components/PillLauncherExpandedView';
import { useCustomerAgentHover } from 'conversations-visitor-experience-components/contexts/CustomerAgentHoverContext';
import { useAIPromptRecommendations } from '../../hooks/useAIPromptRecommendations';
import { toggleOpen } from '../../actions/WidgetActions';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { jsx as _jsx } from "react/jsx-runtime";
const PillLauncherExpandedViewContainer = ({
  clickedFrom
}) => {
  const dispatch = useDispatch();
  const {
    isHoverActive
  } = useCustomerAgentHover();
  const spamProtectionMetadata = useSelector(getSpamProtectionMetadata);
  const spamProtectionEnabled = Boolean(spamProtectionMetadata === null || spamProtectionMetadata === void 0 ? void 0 : spamProtectionMetadata.token);
  const coloring = useSelector(getColoring);
  const {
    recommendedQuestionsForAgent,
    isAIChatBot,
    handlePromptClick,
    handlePromptTrack
  } = useAIPromptRecommendations({
    clickedFrom,
    shouldOpenWidget: true,
    shouldLoadStagedThread: true,
    errorMessage: 'Failed to publish message from pill launcher prompt'
  });
  const firstPrompt = recommendedQuestionsForAgent.length > 0 ? recommendedQuestionsForAgent[0] : undefined;
  const handlePromptBubbleClick = prompt => {
    handlePromptClick(prompt);
    handlePromptTrack();
  };
  const handleOpenWidget = () => {
    dispatch(toggleOpen({
      isOpened: true,
      isUser: true,
      openedFrom: 'pill launcher'
    }));
  };
  if (!isAIChatBot) {
    return null;
  }
  return /*#__PURE__*/_jsx(PillLauncherExpandedView, {
    isVisible: isHoverActive,
    onOpen: handleOpenWidget,
    prompt: firstPrompt,
    onPromptClick: handlePromptBubbleClick,
    spamProtectionEnabled: spamProtectionEnabled,
    coloring: coloring
  });
};
PillLauncherExpandedViewContainer.displayName = 'PillLauncherExpandedViewContainer';
export default PillLauncherExpandedViewContainer;